import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import logo from './assets/headhunters_group_logo.jpeg'

function DownloadPage() {
    const [inputValue, setInputValue] = useState('');
    const [error, setError] = useState('');
    const [open, setOpen] = useState(false);

    const handleInputChange = (event) => {
        setInputValue(event.target.value);
        if (error) {
            setError('');
            setOpen(false);
        }
    };

    const handleDownloadClick = () => {
        if (!inputValue.trim()) {
            setError('Please fill in the input.');
            setOpen(true);
            return;
        }
        const apiUrl = process.env.REACT_APP_API_URL || 'https://resume.dcloud.tech';
        window.location.href = `${apiUrl}/resume/${inputValue}`;
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div style={{ padding: '20px', display: 'flex', flexDirection: 'column', gap: '20px', alignItems: 'center' }}>
            <img src={logo} alt="Headhunters Group Logo" style={{ width: '150px', marginBottom: '20px' }} />
            <TextField
                label="Enter Resume ID"
                variant="outlined"
                value={inputValue}
                onChange={handleInputChange}
                error={Boolean(error)}
                helperText={error ? error : ' '}
                fullWidth
            />
            <Button variant="contained" onClick={handleDownloadClick} color="primary">
                Download
            </Button>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>{"An Error Occurred"}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {error}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary" autoFocus>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default DownloadPage;
